import { API_URL, createRequestActionTypes } from "../../../../../../actions/utilAction";

export const POST_UPLOADRAWDATAFORTARGETS = `${API_URL}/api/MasterDataDefaultTargetSetting/UploadRawDataForTargets`;
export const POST_UPLOADRAWDATAFORBEHAVIOR = `${API_URL}/api/MasterDataDefaultTargetSetting/UploadRawDataForBehaviors`;

export const UploadRawDataActionTypes = {
    post_UploadRawDataForTargets: createRequestActionTypes('POST_UPLOAD_RAW_DATA_FOR_TARGETS'),
    post_UploadRawDataForBehavior: createRequestActionTypes('POST_UPLOADATAFORBEHAVIOR'),
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/uploadRawData/constants/ApiConstants.js